// const DataTableHead = ({ headerGroups, actions }: any) => (
//   <thead>
//     {headerGroups.map((headerGroup: any) => (
//       <tr {...headerGroup.getHeaderGroupProps()} className="bg-gray-100 dark:bg-gray-800">
//         {headerGroup.headers.map((column: any) => (
//           <th
//             {...column.getHeaderProps(column.getSortByToggleProps())}
//             className="text-gray-800 dark:text-gray-200 px-5 py-4 text-left text-sm font-semibold sm:text-base"
//           >
//             <div className="flex items-center">
//               {column.render('Header')}
//               <div className="ml-2 inline-flex flex-col space-y-[2px]">
//                 <span>
//                   <svg className="fill-current" width="10" height="5" viewBox="0 0 10 5">
//                     <path d="M5 0L0 5H10L5 0Z" />
//                   </svg>
//                 </span>
//                 <span>
//                   <svg className="fill-current" width="10" height="5" viewBox="0 0 10 5">
//                     <path d="M5 5L10 0L0 0L5 5Z" />
//                   </svg>
//                 </span>
//               </div>
//             </div>
//           </th>
//         ))}
//         {actions && (
//           <th className="min-w-[120px] text-center">
//             <span className="flex justify-center">Acciones</span>
//           </th>
//         )}
//       </tr>
//     ))}
//   </thead>
// );

// export default DataTableHead;

const DataTableHead = ({ headerGroups, actions }: any) => (
  <thead>
    {headerGroups.map((headerGroup: any) => {
      // ✅ key del headerGroup
      const { key: groupKey, ...groupProps } = headerGroup.getHeaderGroupProps();

      return (
        <tr key={groupKey} {...groupProps} className="bg-gray-100 dark:bg-gray-800">
          {headerGroup.headers.map((column: any) => {
            // ✅ key del header column
            const { key: colKey, ...colProps } = column.getHeaderProps(column.getSortByToggleProps());

            return (
              <th
                key={colKey}
                {...colProps}
                className="text-gray-800 dark:text-gray-200 px-5 py-4 text-left text-sm font-semibold sm:text-base"
              >
                <div className="flex items-center">
                  {column.render('Header')}
                  <div className="ml-2 inline-flex flex-col space-y-[2px]">
                    <span>
                      <svg className="fill-current" width="10" height="5" viewBox="0 0 10 5">
                        <path d="M5 0L0 5H10L5 0Z" />
                      </svg>
                    </span>
                    <span>
                      <svg className="fill-current" width="10" height="5" viewBox="0 0 10 5">
                        <path d="M5 5L10 0L0 0L5 5Z" />
                      </svg>
                    </span>
                  </div>
                </div>
              </th>
            );
          })}

          {actions && (
            <th className="min-w-[120px] text-center">
              <span className="flex justify-center">Acciones</span>
            </th>
          )}
        </tr>
      );
    })}
  </thead>
);

export default DataTableHead;
